import React from "react";
import {
  MdClose,
  MdPerson,
  MdOutlineMail,
  MdOutlinePhone,
  MdSecurity,
  MdOutlineCalendarToday,
  MdVerifiedUser,
  MdDeleteOutline,
} from "react-icons/md";
import profileImg from "../../assets/profile.png";
import "../../styles/DashBoard_Profile.css";
import "../../styles/UserModal.css";

interface ViewUserModalProps {
  isOpen: boolean;
  user: any;
  onClose: () => void;
  canDelete?: boolean;
  onDelete?: (user: any) => void;
}

const ViewUserModal: React.FC<ViewUserModalProps> = ({
  isOpen,
  user,
  onClose,
  canDelete = false,
  onDelete,
}) => {
  if (!isOpen || !user) return null;

  const formattedDate = user.createdAt
    ? new Date(user.createdAt).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
    : "-";

  return (
    <div
      className="user-modal-overlay"
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        width: "100%",
        height: "100%",
        background: "rgba(0, 0, 0, 0.65)",
        backdropFilter: "blur(3px)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 99999,
        padding: "20px",
        boxSizing: "border-box",
      }}
    >
      <div
        className="user-modal-card view-modal-card"
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "#ffffff",
          borderRadius: "12px",
          width: "100%",
          maxWidth: "580px",
          maxHeight: "90vh",
          display: "flex",
          flexDirection: "column",
          boxShadow: "0 25px 60px rgba(0, 0, 0, 0.45)",
          overflow: "hidden",
          boxSizing: "border-box",
          position: "relative",
          zIndex: 100000,
        }}
      >
        <div
          className="user-modal-header"
          style={{
            background: "#e60000",
            color: "#ffffff",
            padding: "16px 22px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            boxSizing: "border-box",
            borderRadius: "12px 12px 0 0",
          }}
        >
          <div
            className="modal-title-wrap"
            style={{ display: "flex", alignItems: "center", gap: "10px" }}
          >
            <MdPerson className="modal-header-icon" size={24} color="#ffffff" />
            <h3 style={{ margin: 0, fontSize: "19px", fontWeight: 600, color: "#ffffff" }}>
              User Details
            </h3>
          </div>
          <button
            type="button"
            className="user-modal-close"
            onClick={onClose}
            style={{
              background: "transparent",
              border: "none",
              color: "#ffffff",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "4px",
              borderRadius: "4px",
              lineHeight: 1,
            }}
          >
            <MdClose size={24} />
          </button>
        </div>

        <div className="view-modal-body">
          {/* <div className="view-user-banner">
            <div className="view-avatar-wrap">
              <img src={profileImg} alt="User" className="view-user-avatar" />
            </div>
            <div className="view-banner-info">
              <h4>{user.username || "User"}</h4>
              <span className={`role-badge ${(user.role || "").toLowerCase()}`}>
                {user.role || "Administrator"}
              </span>
            </div>
          </div> */}

          <div className="view-details-grid">
            <div className="view-detail-item">
              <div className="detail-icon-wrap">
                <MdPerson className="detail-icon" />
              </div>
              <div className="detail-text">
                <label>User Name</label>
                <p>{user.username || "-"}</p>
              </div>
            </div>

            <div className="view-detail-item">
              <div className="detail-icon-wrap">
                <MdOutlineMail className="detail-icon" />
              </div>
              <div className="detail-text">
                <label>Email Address</label>
                <p>{user.emailId || "-"}</p>
              </div>
            </div>

            <div className="view-detail-item">
              <div className="detail-icon-wrap">
                <MdOutlinePhone className="detail-icon" />
              </div>
              <div className="detail-text">
                <label>Phone Number</label>
                <p>{user.mobileNumber || user.phonenumber || "-"}</p>
              </div>
            </div>

            <div className="view-detail-item">
              <div className="detail-icon-wrap">
                <MdSecurity className="detail-icon" />
              </div>
              <div className="detail-text">
                <label>User Role</label>
                <p>{user.role || "Administrator"}</p>
              </div>
            </div>

            <div className="view-detail-item">
              <div className="detail-icon-wrap">
                <MdOutlineCalendarToday className="detail-icon" />
              </div>
              <div className="detail-text">
                <label>Member Since</label>
                <p>{formattedDate}</p>
              </div>
            </div>

            <div className="view-detail-item">
              <div className="detail-icon-wrap">
                <MdVerifiedUser className="detail-icon green" />
              </div>
              <div className="detail-text">
                <label>Status</label>
                <p className="status-active">Active</p>
              </div>
            </div>
          </div>
        </div>

        <div
          className="user-modal-actions view-actions"
          style={{
            display: "flex",
            justifyContent: canDelete && onDelete ? "space-between" : "flex-end",
            alignItems: "center",
            width: "100%",
          }}
        >
          {canDelete && onDelete && (
            <button
              type="button"
              className="action-btn delete"
              style={{
                padding: "8px 16px",
                fontSize: "13px",
                display: "inline-flex",
                alignItems: "center",
                gap: "6px",
                borderRadius: "6px",
                cursor: "pointer",
              }}
              onClick={() => {
                onClose();
                onDelete(user);
              }}
            >
              <MdDeleteOutline size={16} />
              <span>Delete User</span>
            </button>
          )}
          <button type="button" className="user-btn-primary" onClick={onClose}>
            CLOSE
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewUserModal;

